export const SELLING_COMPANIES_GET_ENDPOINT =
  '/api/servicios_fijos/v1/selling_companies';

export const SELLING_COMPANIES_OK = {
  companies: [
    {
      name: 'CLARO',
      companyName: null,
      id: '2',
      vatId: 'RI',
      city: 'Ciudad  Aut. de Buenos Aires',
      country: 'Argentina',
    },
  ],
};

export const SELLING_COMPANIES_OK_REPLY = SELLING_COMPANIES_OK;
